import Component from './Component';
import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

export default class ChangeBar extends Component {

	static defaultProps = {
		title: 'Došlo ke změně formuláře jiným uživatelem.',
		visible: false
	};

	render() {

		let msg;
		if (this.props.items == -1) {
			msg = <div>
				Došlo ke smazání formuláře jiným uživatelem.
			</div>
		}
		else {
			let items = this.props.items ? this.props.items.map((item) => '<b>' + item + '</b>').join(', ') : null;
			items = <span dangerouslySetInnerHTML={{ __html: items }}></span>;
			msg = <div>
					<button onClick={() => this.props.onAcceptChanges()} style={{verticalAlign: 'baseline', padding: '2px 8px', marginRight: 10}} className="btn btn-default"><span className=" icon-checkmark3 position-left"></span>přijmout změny</button>
					{this.props.title}
					<span>
						&nbsp;Změněné položky: {items}
					</span>
				</div>
		}



		return (
			<ReactCSSTransitionGroup
				transitionName="fade"
				transitionEnterTimeout={200}
				transitionLeaveTimeout={200}>
				{this.props.visible &&
				<div className="changed-form-info">
					<span onClick={() => this.props.onClose()} style={{color: '#888', cursor: 'pointer', float:'right', top: 4}} className="icon-cross2"></span>
					{msg}
				</div>}

			</ReactCSSTransitionGroup>
			)
	}
}


// WEBPACK FOOTER //
// ./src/components/ChangeBar.js